import classnames from 'classnames/bind'
import dynamic from 'next/dynamic'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'

import { PlusIcon } from '~/components/Abstracts/Icons'
import { FiltersPanelProps } from '~/components/Panels/FiltersPanel'
import SquaredCta from '~/components/UI/SquaredCta'

import { usePanel } from '~/providers/PanelProvider'

import { CTA } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const FiltersPanel = dynamic(
  () => import('~/components/Panels/FiltersPanelWrapped'),
)

function FiltersTrigger({ className }: FiltersPanelProps) {
  const t = useTranslate()

  const { add: addPanel } = usePanel()

  const openFiltersPanel = (e) => {
    addPanel({
      component: <FiltersPanel />,
      direction: 'right',
    })
  }
  return (
    <SquaredCta
      className={cx(css.FiltersTrigger, className)}
      withBackground
      withBorder
      theme={GlobalThemeColors.White}
      onClick={openFiltersPanel}>
      {t(CTA.FILTER_SORT)}
      <PlusIcon className={css.icon} />
    </SquaredCta>
  )
}

FiltersTrigger.defaultProps = {}

export default FiltersTrigger
